export const tripUrls = {
    searchTrips                    : "/passenger/trip/search",
    getBoardingAndDroppingCounters : "/passenger/counter/search",
    seatLayoutSearch               : "/passenger/seat-layout/search",
    selectTheSeat                  : "/passenger/seat-layout/select-the-seat",
    deselectTheSeat                : "/passenger/seat-layout/deselect-the-seat",
    bookTicket                     : "/passenger/ticket"
};
export default tripUrls;
